import { styled, Chip, ChipProps } from "@mui/material";
import { TranskodeVideoProfile } from "../../../../Core/Api/Types/transkode-video-profile";
import { AssetVideoResolutionAlphaColor } from "../../../../Utils/helpers";

export interface AssetVideoResolutionChipProps extends ChipProps {
  resolution: string;
  uncolored?: boolean;
}

const AssetVideoResolutionChip: React.FC<AssetVideoResolutionChipProps> = (props) => {
  const { resolution, uncolored = false, ...otherProps } = props;
  let videoProfile: TranskodeVideoProfile = TranskodeVideoProfile.SD;

  switch (resolution) {
    case "UHD":
    case "UHD-SDR":
    case "UHD-HDR":
      videoProfile = TranskodeVideoProfile.UHD;
      break;
    case "FourK":
    case "4K":
      videoProfile = TranskodeVideoProfile.FourK;
      break;
    case "HD":
      videoProfile = TranskodeVideoProfile.HD;
      break;
    case "SD":
      videoProfile = TranskodeVideoProfile.SD;
      break;
    case "HDReady":
      videoProfile = TranskodeVideoProfile.HDReady;
      break;
    default:
      return <></>;
  }

  return <StyledChip type={videoProfile} uncolored={uncolored} label={resolution} {...otherProps} />;
};

export default AssetVideoResolutionChip;

const StyledChip = styled(Chip, { shouldForwardProp: (prop) => prop !== "type" && prop !== "uncolored" })<{
  uncolored: AssetVideoResolutionChipProps["uncolored"];
  type: TranskodeVideoProfile;
}>(({ theme, uncolored, type }) => {
  const styles = {};
  if (uncolored) return { ...styles };
  return {
    ...styles,
    color: AssetVideoResolutionAlphaColor(type, 1),
    backgroundColor:
      theme.palette.mode === "dark"
        ? AssetVideoResolutionAlphaColor(type, 0.2)
        : AssetVideoResolutionAlphaColor(type, 0.1),
    ".MuiSvgIcon-root": {
      color: AssetVideoResolutionAlphaColor(type, 1),
    },
  };
});
